import { MotifFormField, MotifInput, MotifLabel } from '@ey-xd/motif-react'
import React, { useState, useEffect } from 'react'
import { updateExtraxtedText } from '../AnnotateSlice'
import { useDispatch } from 'react-redux'
interface UserPermissionItemProps {
  recordIndex: number
  evidenceId: string
  annotationTypeId?: string;
  personName: string
  userGroup: string
  permission: string
  pageNumber?: number // Added 'pageNumber' property
  evidenceAnnotationId?: string
  originalRecord?: any
}
interface UserInfo {
  personName?: string // Added 'name' property
  userGroup?: string // Added 'group' property
  permission?: string // Added 'department' property
}
export const UserPermission = ({
  evidenceId,
  recordIndex,
  annotationTypeId,
  personName,
  userGroup,
  permission,
  pageNumber,
  evidenceAnnotationId,
  originalRecord,
}: UserPermissionItemProps) => {
  const changed = (field: string, current: any) =>
    originalRecord != null && (current ?? '') !== (originalRecord[field] ?? '')
  const dispatch = useDispatch()
  const [userPermission, setUserPermission] = useState<UserInfo | null>({
    personName: personName ? personName : '',
    userGroup: userGroup? userGroup : '',
    permission: permission? permission : '',
  })
  useEffect(() => {
    setUserPermission({
      personName: personName ? personName : '',
      userGroup: userGroup ? userGroup : '',
      permission: permission ? permission : '',
    })
  }, [personName, userGroup, permission])
  useEffect(() => {
    dispatch(
      updateExtraxtedText({
        evidenceId: evidenceId,
        recordIndex: recordIndex,
        annotationTypeId: annotationTypeId,
        extractedText: userPermission,
        pageNumber: pageNumber ? pageNumber : 1, // Use the provided pageNumber or default to 1
        evidenceAnnotationId: evidenceAnnotationId,
      }),
    )
  }, [userPermission])
  const handleUserDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setUserPermission((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }))
  }
  return (
    <div className="user-detail-tab">
        <div className={changed('personName', userPermission?.personName) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="name" position="in">
            Name
          </MotifLabel>
          <MotifInput
            id="personName"
            label="Name"
            name="personName"
            onChange={handleUserDetailsChange}
            aria-label="name"
            labelPosition="in"
            value={userPermission?.personName}
            hideClearButton
            autocomplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('userGroup', userPermission?.userGroup) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="group" position="in">
            Group
          </MotifLabel>
          <MotifInput
            id="group"
            name="userGroup"
            labelPosition="in"
            value={userPermission?.userGroup}
            onChange={handleUserDetailsChange}
            hideClearButton
            autocomplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('permission', userPermission?.permission) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel
            aria-label="Permission"
            position="in"
          >
            Permission
          </MotifLabel>
          <MotifInput
            id="Permission"
            name="permission"
            labelPosition="in"
            value={userPermission?.permission}
            onChange={handleUserDetailsChange}
            hideClearButton
            autocomplete="off"
          />
        </MotifFormField>
        </div>
    </div>
  )
}
